import { z } from 'zod';

import { ReportResolutionSchema } from '../report-resolution/report-resolution';

/** The reviewer's own note. Staff-facing — no member ever reads it. */
export const RESOLUTION_NOTE_MAX_LENGTH = 2000;

/**
 * A reviewer's verdict on a report.
 *
 * **The resolution is a field here, not the route**, and that is the opposite of
 * the choice `ReviewMatchSchema` made for Trust — deliberately, because the two
 * surfaces differ in exactly the way that argument turns on. Trust's confirm
 * *bans an account*, so one request expressible two ways is a question with no
 * correct answer. Resolving a report ends **no** account: it records what the
 * reviewer concluded, and the enforcement that may follow is a separate, audited
 * act through `UserModerationService` (N9/N20). Three sibling verdicts that do
 * the same amount of damage — none — belong on one route as one enum, or the
 * admin grows three endpoints that differ by a string.
 *
 * A **blank** note normalizes to `null`, so an empty quotation is never rendered
 * under "the reviewer said".
 */
export const ReportResolveSchema = z
  .object({
    resolution: ReportResolutionSchema,
    note: z
      .string()
      .trim()
      .max(RESOLUTION_NOTE_MAX_LENGTH)
      .nullable()
      .default(null)
      .transform((note) => (note === null || note === '' ? null : note)),
  })
  .strict();

export type ReportResolveRequest = z.infer<typeof ReportResolveSchema>;
